export const adminpayment = [
    {
        id: 3457,
        acctName: "Gbenga Akinnukawe",
        acctNumber: "akinu@gmail.com",
        ccv: "Your product have been sent to the farmer",
        balance:"In review",
        dateTransfer:"In review",
        transaction:"In review",
        status:"In review",
        action:"In review",
        tbcName: "pay-general-tbody",
        tbcIcon: "styletableicon"
     },
     {
        id: 3457,
        acctName: "Gbenga Akinnukawe",
        acctNumber: "akinu@gmail.com",
        ccv: "Your product have been sent to the farmer",
        balance:"In review",
        dateTransfer:"In review",
        transaction:"In review",
        status:"In review",
        action:"In review",
        tbcName: "pay-general-tbody",
        tbcIcon: "styletableicon"
     },
     {
        id: 3457,
        acctName: "Gbenga Akinnukawe",
        acctNumber: "akinu@gmail.com",
        ccv: "Your product have been sent to the farmer",
        balance:"In review",
        dateTransfer:"In review",
        transaction:"In review",
        status:"In review",
        action:"In review",
        tbcName: "pay-general-tbody",
        tbcIcon: "styletableicon"
     },
     {
        id: 3457,
        acctName: "Gbenga Akinnukawe",
        acctNumber: "akinu@gmail.com",
        ccv: "Your product have been sent to the farmer",
        balance:"In review",
        dateTransfer:"In review",
        transaction:"In review",
        status:"In review",
        action:"In review",
        tbcName: "pay-general-tbody",
        tbcIcon: "styletableicon"
     }
]